"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionContainer = exports.OptionsContainer = exports.TokenLabel = exports.TokenRowContent = exports.InputWrap = exports.TokenRow = exports.TokenInputContainer = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const TokenInputContainerBgColor = ({ isHover, theme, error, isFocused, }) => {
    var _a, _b;
    if (error) {
        return theme.colors.accent.error.faded;
    }
    if (isFocused)
        return 'white';
    if (isHover && !((_a = theme.common) === null || _a === void 0 ? void 0 : _a.outlined))
        return theme.colors.neutral[20];
    return ((_b = theme.common) === null || _b === void 0 ? void 0 : _b.outlined) ? 'transparent' : theme.colors.neutral[10];
};
const TokenInputContainerBorderColor = ({ isHover, theme, error, isFocused, }) => {
    var _a;
    if (error) {
        return theme.colors.accent.error.normal;
    }
    if (isFocused)
        return theme.colors.neutral[50];
    if (isHover)
        return theme.colors.neutral[20];
    return ((_a = theme.common) === null || _a === void 0 ? void 0 : _a.outlined) ? theme.colors.neutral[10] : 'transparent';
};
exports.TokenInputContainer = theme_1.styled.div `
  position: relative;
  width: 100%;
  height: 54px;
  padding: 24px 14px 0;
  box-sizing: border-box;
  border: 2px solid
    ${({ theme, isNotEmpty, error, isFocused }) => TokenInputContainerBorderColor({
    isHover: false,
    theme,
    isNotEmpty,
    error,
    isFocused,
})};
  background-color: ${({ theme, isNotEmpty, error, isFocused }) => TokenInputContainerBgColor({
    isHover: false,
    theme,
    isNotEmpty,
    error,
    isFocused,
})};
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : theme.common.radius; }};

  &:hover {
    background: ${({ theme, isNotEmpty, error, isFocused }) => TokenInputContainerBgColor({
    isHover: true,
    theme,
    isNotEmpty,
    error,
    isFocused,
})};
    border: 2px solid
      ${({ theme, isNotEmpty, error, isFocused }) => TokenInputContainerBorderColor({
    isHover: true,
    theme,
    isNotEmpty,
    error,
    isFocused,
})};
  }

  &:disabled {
    background: ${({ theme }) => { var _a; return ((_a = theme.common) === null || _a === void 0 ? void 0 : _a.outlined) ? 'transparent' : theme.colors.neutral[30]; }};
    opacity: 1;
  }

  & input {
    outline: none;
    border: none;
    &:focus,
    &:hover {
      outline: none;
      border: none;
    }
  }
`;
exports.TokenRow = theme_1.styled.div `
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: 2px;

  &::-webkit-scrollbar {
    width: 2px;
  }
`;
exports.InputWrap = theme_1.styled.div `
  display: inline-block;
`;
exports.TokenRowContent = theme_1.styled.div `
  white-space: nowrap;
  width: auto;
  display: inline-block;
`;
exports.TokenLabel = theme_1.styled.div `
  position: absolute;
  top: ${({ isNotEmpty }) => (isNotEmpty ? '6' : '15')}px;
  z-index: 1;
  user-select: none;
  transition: font-size 200ms, position 200ms;
  font-size: ${({ isNotEmpty }) => (isNotEmpty ? '12' : '18')}px;
  color: ${({ theme, error }) => error ? theme.colors.text.error : theme.colors.text.secondary};
`;
exports.OptionsContainer = theme_1.styled.div `
  width: 100%;

  ${({ isStaticOptions }) => !isStaticOptions
    ? (0, theme_1.css) `
          position: absolute;
          left: 0;
          top: 64px;
        `
    : (0, theme_1.css) `
          margin-top: 8px;
        `}
  z-index: 1;
`;
exports.SuggestionContainer = theme_1.styled.div `
  margin-top: 8px;
`;
